module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/86c0614a225dd4e26ccd51cd06e3b2af.png";